import React, { TableRow, TableCell, Collapse } from '@mui/material';
import { useState } from 'react';
import { format } from 'date-fns';
import { Collapser, SaleForm } from 'components';
import { SalesRowProps } from './SaleRowProps';

export const SaleRow = ({ row }: SalesRowProps) => {
	const [open, setOpen] = useState(false);
	return (
		<>
			<TableRow
				sx={{ '& > *': { borderBottom: 'unset' } }}
				onClick={() => {
					setOpen(!open);
				}}
			>
				<TableCell colSpan={1}>
					<Collapser isAdd={false} open={open} />
				</TableCell>
				<TableCell colSpan={2}>{format(row.timeStamp, 'yyyy-MM-dd')}</TableCell>
				<TableCell colSpan={4}>{`${row.user.firstName} ${row.user.lastName}`}</TableCell>
				<TableCell colSpan={4}>{row.product.name}</TableCell>
			</TableRow>
			<TableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
					<Collapse in={open} timeout='auto'>
						<SaleForm row={row} />
					</Collapse>
				</TableCell>
			</TableRow>
		</>
	);
}
